import React, { useState, useEffect } from "react";
import { putCamion as modifCamion } from "../helpers/rutaCamiones";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const tiposUnidad = [
  "CAMIONETA",
  "CAMION",
  "TRACTOR",
  "COSECHADORA",
  "PULVERIZADORA",
  "MAQUINARIA",
  "MOTO",
  "AUTO",
  "OTRO",
];

const modosControl = ["KM", "HORAS"];
const tiposCombustible = ["GASOIL", "NAFTA"];

const getModoPorTipoUnidad = (tipoUnidad) => {
  if (
    ["TRACTOR", "COSECHADORA", "PULVERIZADORA", "MAQUINARIA"].includes(
      tipoUnidad
    )
  ) {
    return "HORAS";
  }

  return "KM";
};

const getCombustiblePorTipoUnidad = (tipoUnidad) => {
  if (["MOTO", "AUTO"].includes(tipoUnidad)) {
    return "NAFTA";
  }

  return "GASOIL";
};

const ModalFormCamion = ({ camion, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const initialValues = {
    codcam: "",
    camion: "",
    patente: "",
    tipoUnidad: "CAMIONETA",
    modoControl: "KM",
    combustibleHabitual: "GASOIL",
    ultimoKmTablero: "",
    ultimoHorometro: "",
    observaciones: "",
  };

  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    if (camion && camion._id) {
      setFormValues({
        codcam: camion.codcam || "",
        camion: camion.camion || "",
        patente: camion.patente || "",

        tipoUnidad: camion.tipoUnidad || "CAMIONETA",
        modoControl: camion.modoControl || "KM",
        combustibleHabitual: camion.combustibleHabitual || "GASOIL",

        ultimoKmTablero:
          camion.ultimoKmTablero !== undefined && camion.ultimoKmTablero !== null
            ? camion.ultimoKmTablero
            : "",

        ultimoHorometro:
          camion.ultimoHorometro !== undefined && camion.ultimoHorometro !== null
            ? camion.ultimoHorometro
            : "",

        observaciones: camion.observaciones || "",
      });
    }
  }, [camion]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "tipoUnidad") {
      const modoControl = getModoPorTipoUnidad(value);
      const combustibleHabitual = getCombustiblePorTipoUnidad(value);

      setFormValues({
        ...formValues,
        tipoUnidad: value,
        modoControl,
        combustibleHabitual,
      });

      return;
    }

    if (["camion", "patente", "observaciones"].includes(name)) {
      setFormValues({
        ...formValues,
        [name]: value.toUpperCase(),
      });

      return;
    }

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formValues,
        ultimoKmTablero: Number(formValues.ultimoKmTablero) || 0,
        ultimoHorometro: Number(formValues.ultimoHorometro) || 0,
      };

      const resp = await modifCamion(camion._id, payload);
      console.log("✅ Vehículo / maquinaria actualizado:", resp);

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1800);
    } catch (error) {
      console.error("❌ Error al actualizar vehículo / maquinaria:", error);
      alert("Error al actualizar vehículo / maquinaria");
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Vehículo / Maquinaria</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-row">
              <div className="form-group mt-2 col-sm-6">
                <label>Vehículo / Maquinaria</label>
                <input
                  type="text"
                  className="form-control"
                  name="camion"
                  maxLength="50"
                  required
                  value={formValues.camion}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-2 col-sm-3">
                <label>Patente / Identificación</label>
                <input
                  type="text"
                  className="form-control"
                  name="patente"
                  maxLength="15"
                  required
                  value={formValues.patente}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-2 col-sm-3">
                <label>Tipo de unidad</label>
                <select
                  className="form-control"
                  name="tipoUnidad"
                  value={formValues.tipoUnidad}
                  onChange={handleChange}
                  required
                >
                  {tiposUnidad.map((tipo) => (
                    <option key={tipo} value={tipo}>
                      {tipo}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group mt-3 col-sm-4">
                <label>Modo de control</label>
                <select
                  className="form-control"
                  name="modoControl"
                  value={formValues.modoControl}
                  onChange={handleChange}
                  required
                >
                  {modosControl.map((modo) => (
                    <option key={modo} value={modo}>
                      {modo === "KM" ? "Por kilómetros" : "Por horas"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-4">
                <label>Combustible habitual</label>
                <select
                  className="form-control"
                  name="combustibleHabitual"
                  value={formValues.combustibleHabitual}
                  onChange={handleChange}
                  required
                >
                  {tiposCombustible.map((tipo) => (
                    <option key={tipo} value={tipo}>
                      {tipo}
                    </option>
                  ))}
                </select>
              </div>

              {formValues.modoControl === "KM" && (
                <div className="form-group mt-3 col-sm-4">
                  <label>Último Km tablero</label>
                  <input
                    type="number"
                    className="form-control"
                    name="ultimoKmTablero"
                    min="0"
                    step="1"
                    value={formValues.ultimoKmTablero}
                    onChange={handleChange}
                    placeholder="Opcional"
                  />
                </div>
              )}

              {formValues.modoControl === "HORAS" && (
                <div className="form-group mt-3 col-sm-4">
                  <label>Último horómetro</label>
                  <input
                    type="number"
                    className="form-control"
                    name="ultimoHorometro"
                    min="0"
                    step="0.01"
                    value={formValues.ultimoHorometro}
                    onChange={handleChange}
                    placeholder="Opcional"
                  />
                </div>
              )}
            </div>

            <div className="form-row">
              <div className="form-group mt-3 col-sm-12">
                <label>Observaciones</label>
                <textarea
                  className="form-control"
                  name="observaciones"
                  rows="2"
                  maxLength="200"
                  value={formValues.observaciones}
                  onChange={handleChange}
                  placeholder="Observaciones internas"
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>

            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>✅</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormCamion;